import { Button } from 'antd';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { globalConst, isEmptyArr } from 'modules/global';
import { UniversityTypes } from 'modules/universities';

import { EmptyData, Visible } from 'components';

interface IUniversity {
  id: string;
  name: string;
  image: string;
  logo: string;
  title: string;
  type: string;
  slug?: string;
  direction_count?: number;
}

interface IProps {
  fieldId: string | null;
  results: any[];
}

const OTMUniversities = ({ fieldId, results }: IProps) => {
  const t = useTranslations();

  const selectedField = results.find(item => item.id === fieldId);
  const universities: IUniversity[] = selectedField?.universities || [];

  return (
    <div>
      <div className="md:-0 p-3 sm:mt-5">
        <div className="shadow-xs mb-3 flex items-center justify-between rounded-xl bg-white p-4">
          <div className="text-xl font-medium">{t('Universitetni_tanlang')} 🎓</div>
          <div className="hidden sm:block">
            <Link href="/">
              <Button className="!duration-400 !rounded-lg !border-none !bg-red-50 !px-8 !py-5 !font-medium !text-red-500 !transition !ease-in-out hover:!bg-red-500 hover:!text-white">
                {t('yakunlash')}
              </Button>
            </Link>
          </div>
        </div>
        <div className="mb-23 grid grid-cols-1 gap-4 md:grid-cols-2">
          <Visible
            if={isEmptyArr(universities)}
            else={universities.map(uni => (
              <Link
                href={`${uni?.type === UniversityTypes.PRIVATE ? globalConst.pageNames.PRIVATE_UNIVERSITIES : globalConst.pageNames.UNIVERSITIES}/${uni?.slug}`}
                key={uni.id}
                className="h-full cursor-pointer rounded-xl bg-white"
              >
                <div className="flex h-full flex-col p-3">
                  <div className="flex items-center gap-2">
                    <Image
                      src={uni?.logo || '/images/toshmi.png'}
                      alt={uni.name.slice(0, 2)}
                      width={40}
                      title="universitetning logosi"
                      height={40}
                      className="min-w-10 rounded-full border border-gray-200"
                    />
                    <div className="text-base font-medium">{uni?.name}</div>
                  </div>

                  <div className="mt-4 line-clamp-2 text-xs text-gray-500">{uni?.title ?? t('tavsif_mavjud_emas')}</div>

                  <div className="mt-auto flex items-center justify-between pt-4">
                    <span className="text-sm text-blue-600">{t('Yonalishlar')} - {uni?.direction_count}</span>
                    <span
                      className={classNames('rounded-full px-2 py-1 text-xs', {
                        'bg-teal-50 text-teal-500': uni.type === UniversityTypes.PUBLIC,
                        'bg-orange-50 text-orange-500': uni.type === UniversityTypes.PRIVATE
                      })}
                    >
                      <Visible
                        if={uni.type === UniversityTypes.PUBLIC}
                        else={<Visible if={uni.type === UniversityTypes.PRIVATE}>{t('xususiy')}</Visible>}
                      >
                        {t('davlat')}
                      </Visible>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          >
            <EmptyData title={t('malumot_topilmadi')} />
          </Visible>
        </div>
      </div>

      <div className="rounded-t-4xl fixed bottom-0 h-20 w-full bg-white p-4 sm:hidden">
        <Link href="/">
          <Button className="!duration-400 !w-full !rounded-lg !border-none !bg-red-50 !px-8 !py-6 !font-medium !text-red-500 !transition !ease-in-out hover:!bg-red-500 hover:!text-white">
            {t('yakunlash')}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default OTMUniversities;
